module.exports = __webpack_public_path__ + "school/img/biaozhunTj.661d687a.jpg";